'use client';

import { useState, useEffect } from 'react';
import Image from 'next/image';
import Link from 'next/link';

const InnerPageHeader = () => {
  const [user, setUser] = useState<any>(null);
  const [isLoggedIn, setIsLoggedIn] = useState(false);

  useEffect(() => {
    // Check if user is logged in
    const token = localStorage.getItem('authToken');
    const userData = localStorage.getItem('user');
    
    if (token && userData) {
      setUser(JSON.parse(userData));
      setIsLoggedIn(true);
    }
  }, []);

  return (
    <header className="relative z-50 bg-white">
      <div className="max-w-[1920px] mx-auto px-[80px] py-[40px]">
        <div className="flex items-center justify-between">
          {/* Logo */}
          <Link href="/" className="flex items-center" style={{ width: '367.62px', height: '94px' }}>
            <Image
              src="/logo-dark.png"
              alt="Female Fitness Finder"
              width={367.62}
              height={94}
              className="object-contain"
              priority
            />
          </Link>

          {/* Navigation */}
          <nav className="hidden md:flex items-center gap-[40px]">
            <Link href="/" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] font-normal leading-[100%] tracking-[0%]">Home</Link>
            <Link href="/about" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] font-normal leading-[100%] tracking-[0%]">About</Link>
            <Link href="/search-process" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] font-normal leading-[100%] tracking-[0%]">Directory</Link>
            <Link href="/for-women" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] font-normal leading-[100%] tracking-[0%]">For Women</Link>
            <Link href="/contact" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] font-normal leading-[100%] tracking-[0%]">Contact</Link>
          </nav>

          {/* Right side actions */}
          <div className="flex items-center gap-[40px]">
            <svg className="w-6 h-6 text-[#2E2A3A]" fill="currentColor" viewBox="0 0 24 24">
              <path d="M15.5 14h-.79l-.28-.27C15.41 12.59 16 11.11 16 9.5 16 5.91 13.09 3 9.5 3S3 5.91 3 9.5 5.91 16 9.5 16c1.61 0 3.09-.59 4.23-1.57l.27.28v.79l5 4.99L20.49 19l-4.99-5zm-6 0C7.01 14 5 11.99 5 9.5S7.01 5 9.5 5 14 7.01 14 9.5 11.99 14 9.5 14z"/>
            </svg>
            
            {isLoggedIn && user ? (
              // Logged in user - show profile
              <Link href="/dashboard" className="flex items-center gap-3 hover:opacity-80 transition-opacity">
                {user.profilePicture ? (
                  <img
                    src={user.profilePicture}
                    alt={user.fullName}
                    className="w-10 h-10 rounded-full object-cover border-2 border-[#8a7296]"
                  />
                ) : (
                  <div className="w-10 h-10 bg-[#8a7296] rounded-full flex items-center justify-center border-2 border-[#8a7296]">
                    <span className="text-white text-[16px] font-['Gotham_Rounded',sans-serif] font-bold">
                      {user.fullName?.charAt(0).toUpperCase()}
                    </span>
                  </div>
                )}
                <span className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] font-medium">
                  {user.fullName}
                </span>
              </Link>
            ) : (
              // Not logged in - show Register/Login
              <>
                <Link href="/signup" className="px-[34px] py-[20px] bg-[#8a7296] text-white font-['Archivo',sans-serif] text-[18px] font-medium leading-[100%] tracking-[0%] rounded-[10px] hover:bg-[#4C3E58] transition-colors flex items-center gap-2">
                  Register
                  <svg className="w-3 h-3" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M14 5l7 7m0 0l-7 7m7-7H3" />
                  </svg>
                </Link>
                <Link href="/login" className="font-['Archivo',sans-serif] text-[18px] text-[#2E2A3A] font-normal leading-[100%] tracking-[0%]">Log In</Link>
              </>
            )}
          </div>
        </div>
      </div>
    </header>
  );
};

export default InnerPageHeader;
